import React from 'react';

import styles from './Address.module.scss';

import { EXIT_MODAL } from '../../redux/modules/modals/modals.module';
import ModalLink from '../../components/Shared/Modal/ModalLink/ModalLink';
import {
  calculateAndFormatUnixDates,
  futureDate,
} from '../../utils/date-utils';

const AddressTile = (addressProps) => {
  const { address, primaryAddress } = addressProps;
  const returnMail = address.serviceId;
  const restrictAddress = !returnMail && address.restrictAddress;

  return (
    <div className="blocked-content blocked_data">
      <div className={`${styles.name} blocked_data`}>
        {primaryAddress.fullName}
      </div>
      <div className={`${styles.address} blocked_data`}>{address.street1}</div>
      {address.street2 && (
        <div className={`${styles.address} blocked_data`}>
          {address.street2}
        </div>
      )}
      <div className={`${styles.address} blocked_data`}>
        {address.city}, {address.state} {address.zip}
      </div>
      {returnMail && (
        <div className={styles.address}>
          <span className={styles['disable-text']}>
            Address Marked as Undeliverable
          </span>
          {'  '}-{'  '}
          <ModalLink
            link={
              <div
                aria-label="change-address-button"
                className="error-link"
                role="link"
              >
                Change address
              </div>
            }
            linkStyle="link"
            modalProps={{
              url: 'https://www.troweprice.com/usis/my-accounts/profile/contact-information',
              description:
                'Your information will not be saved and you will not be able to mail in an RMD to your new address until after the 15 day holding period.',
            }}
            modalName={EXIT_MODAL}
          />
        </div>
      )}

      {restrictAddress && (
        <div className={styles.address}>
          <span className={styles['disable-text']}>
            Address Pending Verification
          </span>{' '}
          - Available on{' '}
          {calculateAndFormatUnixDates(futureDate(address.effectiveDate, 15))}
        </div>
      )}
    </div>
  );
};

export default AddressTile;
